/**
 * Tag.tsx — wrapper rundt @carbon/react Tag
 *
 * Beholder vår eksisterende API (kind: success/neutral/warning/danger/blue)
 * men bruker Carbon Tag internt. Mapper våre kind-verdier til Carbon-typer.
 *
 * Bruk:
 *   <Tag kind="success">Aktiv</Tag>
 *   <Tag kind="neutral">Inaktiv</Tag>
 */

import { ReactNode } from 'react';
import { Tag as CarbonTag } from '@carbon/react';

type TagKind = 'success' | 'neutral' | 'warning' | 'danger' | 'blue';

// Mapping fra vår kind-API til Carbon Tag-typer
const KIND_TO_TYPE: Record<TagKind, string> = {
  success: 'green',
  neutral: 'gray',
  warning: 'magenta', // Carbon har ikke gul — magenta er nærmeste "advarsel"
  danger: 'red',
  blue: 'blue',
};

interface TagProps {
  kind: TagKind;
  children: ReactNode;
  /** Valgfri ekstra klasse (CSS Modules-komposisjon fra kallende komponent) */
  className?: string;
}

export default function Tag({ kind, children, className }: TagProps) {
  return (
    <CarbonTag type={(KIND_TO_TYPE[kind] || 'gray') as 'green' | 'gray' | 'magenta' | 'red' | 'blue'} className={className}>
      {children}
    </CarbonTag>
  );
}
